<template>
  <div class="bg-light-gray mb-2">
    <validation-observer ref="formModalObserver" novalidate tag="form">
      <div class="row">
        <div class="col-12 mb-3">
          <icon-view
            :has-border="false"
            icon="fas fa-clock text-orange"
            icon-size="17px"
            title="Extensión de Préstamo del Equipo"
            variant="custom-icon-view"
            icon-background="white"
          />
        </div>
        <div class="col-12 mb-4">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-date-picker
              required
              v-model="model.returnDate"
              :min-date="initialDate"
              :max-date="maxDate"
              placeholder="DD/MM/YYYY"
              class="custom-datetime-picker-container"
              container-class="w-100"
              :error="errors[0]"
              :custom-error-msg="'La fecha es requerida'"
              label="Fecha de Devolución de Equipo:"
            />
          </validation-provider>
        </div>
        <div class="col-12 mb-4">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-text-area
              id="txtComment"
              :maxlength="3000"
              placeholder="Escribe un comentario"
              label="Comentario:"
              v-model="model.comment"
              :error="errors[0]"
              :custom-error-msg="'Este campo es requerido'"
              :show-char-count="true"
              :count-classes="['d-block text-right']"
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="$emit('close')"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="handlerSave"
      />
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import IconView from 'icon-view';
import CustomTextArea from '@quisit/custom-text-area';
import CustomDatePicker from 'custom-date-picker';

import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import moment from 'moment';

export default {
  name: 'LoanExtension',
  components: {
    ActionButton,
    IconView,
    CustomTextArea,
    CustomDatePicker,
  },
  mixins: [alertMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      model: {
        comment: '',
        returnDate: null,
      },
    };
  },
  computed: {
    initialDate() {
      return new Date(this.item.returnDate) || new Date();
    },
    maxDate() {
      const date = new Date(this.item.returnDate) || new Date();
      return moment(date)
        .add(10, 'M')
        .toDate();
    },
  },
  methods: {
    async handlerSave() {
      const isvalid = await this.$refs.formModalObserver.validate();
      if (!isvalid) {
        this.ShowToast(
          'Alerta',
          'Por favor completa los campos requeridos.',
          'error'
        );
        return;
      }

      const isConfirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea guardar la información documentada?`,
        'Sí',
        'No'
      );

      if (!isConfirmed) {
        return;
      }

      const payload = {
        loanId: this.item.loanId,
        extensionDate: this.model.returnDate,
        comment: this.model.comment,
      };

      this.$emit('save', payload);
    },
  },
};
</script>
<style lang="scss"></style>
